/**
 * A dropdown with only flat (non-nested) links only ever gets one grid
 * column from the mega-menu Liquid (it only splits into columns when items
 * carry their own images). That's fine for a handful of links, but a long
 * flat list — like a full category list — ends up as one very tall column.
 * Auto-detect that case here and let CSS flow it into a few columns
 * instead, rather than changing the shared mega-menu markup (which every
 * dropdown in the header uses).
 *
 * Submenu content can be injected after the initial page load (section
 * hydration — see header-menu.js), so a single check on page load isn't
 * reliable. header-menu.js dispatches a bubbling 'megaMenu:hover' event
 * once it confirms a submenu is genuinely populated, which is a safe point
 * to check.
 */
(function () {
  function applyMultiColumn() {
    document.querySelectorAll('.mega-menu__column').forEach(function (column) {
      if (column.classList.contains('mega-menu__column--multi')) return;
      var itemCount = column.querySelectorAll(':scope > div').length;
      if (itemCount > 10) {
        column.classList.add('mega-menu__column--multi');
      }
    });
  }

  document.addEventListener('megaMenu:hover', applyMultiColumn);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMultiColumn);
  } else {
    applyMultiColumn();
  }
})();
